"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Snail = exports.SnailStyle = void 0;
const BallScrewElement_1 = require("./BallScrewElement");
const Rows_1 = require("./Rows");
const QuatableElement_1 = require("./QuatableElement");
var SnailStyle;
(function (SnailStyle) {
    SnailStyle[SnailStyle["Circle"] = 0] = "Circle";
    SnailStyle[SnailStyle["TopFlat"] = 1] = "TopFlat";
    SnailStyle[SnailStyle["BottomFlat"] = 2] = "BottomFlat";
    SnailStyle[SnailStyle["BothFlat"] = 3] = "BothFlat";
})(SnailStyle = exports.SnailStyle || (exports.SnailStyle = {}));
/**
 * Class to draw a snail
 */
class Snail extends BallScrewElement_1.BallScrewElement {
    constructor(two) {
        super();
        this.part4Obj = null;
        this.two = two;
    }
    /**
     * Draw a linear snail
     * @param two
     * @param screwDR
     * @param ballsDR
     * @param heightD1
     * @param heightD6
     * @param part1
     * @param part2
     * @param part3
     * @param part4
     * @param selected
     */
    drawLinear(two, screwDR, ballsDR, heightD1, heightD6, part1, part2, part3, part4, selected) {
        this.two = two;
        this.screwDR = screwDR;
        this.ballsDR = ballsDR;
        this.heightD1 = heightD1;
        this.heightD6 = heightD6;
        this.part1 = part1;
        this.part2 = part2;
        this.part3 = part3;
        this.part4 = part4;
        this.selected = selected;
        // Groups can take an array of shapes and/or groups.
        this.group = this.two.makeGroup();
        const part1group = this.two.makeGroup();
        const part1Obj = this.two.makeRectangle(this.part1 / 2, 0, this.part1, this.heightD1);
        part1Obj.stroke = "black";
        part1Obj.fill = "#fff";
        part1group.add(part1Obj);
        this.registerForQuote([part1Obj], "bottom", 100, parseFloat(this.selected.L3.toString()).toFixed(0).toString(), false, BallScrewElement_1.BallScrewElement.COLORQUOTE, true, true, "left");
        this.group.add(part1group);
        this.registerForQuote([part1Obj], "outercenter", 0, "Ø " + parseFloat(this.selected.D1.toString()).toFixed(0).toString() + " -0.2 / -0.3");
        const part2Obj = this.two.makeRectangle(part1Obj.translation.x + (this.part1 / 2) + this.part2 / 2, 0, this.part2, this.heightD6);
        part2Obj.stroke = "black";
        part2Obj.fill = "#fff";
        this.group.add(part2Obj);
        this.registerForQuote([part2Obj], "bottom", 100, parseFloat(this.selected.L7.toString()).toFixed(0).toString());
        const part3Obj = this.two.makeRectangle(part2Obj.translation.x + (this.part2 / 2) + this.part3 / 2, 0, this.part3, this.heightD1);
        part3Obj.stroke = "black";
        part3Obj.fill = "#fff";
        this.group.add(part3Obj);
        this.registerForQuote([part3Obj], "bottom", 80, parseFloat(this.selected.L1.toString()).toFixed(0).toString(), false, BallScrewElement_1.BallScrewElement.COLORQUOTE, true, false);
        this.registerForQuote([part3Obj], "outercenter", 0, "Ø " + parseFloat(this.selected.D1.toString()).toFixed(0).toString() + " g6");
        const part4group = this.two.makeGroup();
        this.part4Obj = this.two.makeRectangle(part3Obj.translation.x + (this.part3 / 2) + this.part4 / 2, 0, this.part4, this.heightD1 - 5);
        this.part4Obj.stroke = "black";
        this.part4Obj.fill = "#fff";
        part4group.add(this.part4Obj);
        this.registerForQuote([part1Obj, this.part4Obj], "bottom", 120, parseFloat(this.selected.L14.toString()).toFixed(0).toString());
        this.registerForQuote([part3Obj, this.part4Obj], "bottom", 100, "(" +
            parseFloat((this.selected.L14 - this.selected.L3 - this.selected.L7).toString()).toFixed(0).toString() +
            ")", false, BallScrewElement_1.BallScrewElement.COLORQUOTE, true, true);
        this.registerForQuote([this.part4Obj], "outerright", 0.7, "Ø " + parseFloat(this.selected.D1.toString()).toFixed(0).toString() + " -0.2 / -0.3");
        const hiddenW = this.ballsDR * 1.5;
        const hiddenPart4Obj = this.two.makeRectangle((part3Obj.translation.x + (this.part3 / 2) + this.part4 / 2) + (this.part4 / 2) - hiddenW / 2, 0, hiddenW, this.heightD1 - (this.screwDR / 4));
        hiddenPart4Obj.stroke = "black";
        hiddenPart4Obj.noFill();
        hiddenPart4Obj.dashes = Rows_1.Rows.getDashesForStyle(Rows_1.RowsStyle.Hidden);
        hiddenPart4Obj.linewidth = 0.5;
        part4group.add(hiddenPart4Obj);
        this.group.add(part4group);
        const hiddenPart1Obj = this.two.makeRectangle(hiddenW / 2, 0, hiddenW, this.heightD1 - (this.screwDR / 4));
        hiddenPart1Obj.stroke = "black";
        hiddenPart1Obj.noFill();
        hiddenPart1Obj.dashes = Rows_1.Rows.getDashesForStyle(Rows_1.RowsStyle.Hidden);
        hiddenPart1Obj.linewidth = 0.5;
        this.group.add(hiddenPart1Obj);
        return this.group;
    }
    /**
     * Draw snail in a frontal view
     * @param two
     * @param radius
     * @param style
     * @param num
     * @param showAxis
     */
    drawFront(two, ballScrew, scale, style, num = 6, showAxis = true) {
        // Groups can take an array of shapes and/or groups.
        this.group = two.makeGroup();
        const radius = ballScrew.D6 * scale;
        switch (style) {
            case SnailStyle.Circle:
                this.group.add(this.drawCircleBase(two, ballScrew, scale));
                break;
            case SnailStyle.BottomFlat:
                this.group.add(this.drawCircleBottomFlat(two, ballScrew, scale));
                break;
            case SnailStyle.TopFlat:
                this.group.add(this.drawCircleTopFlat(two, ballScrew, scale));
                break;
            case SnailStyle.BothFlat:
                this.group.add(this.drawCircleBothFlat(two, ballScrew, scale));
                break;
        }
        this.drawInnerCircle(two, this.group, radius / 2, (ballScrew.D5 / 2) * scale, num, ballScrew);
        if (showAxis) {
            this.drawAxis(two, this.group, radius, num);
        }
        // Groups can take an array of shapes and/or groups.
        const or = radius / 1.7;
        let arc = null;
        if (num === 8) {
            arc = this.drawArc(two, radius / 2, radius / 2, or, -(Math.PI / 6), 0);
        }
        else {
            arc = this.drawArc(two, radius / 2, radius / 2, or, -(Math.PI / 8), 0);
        }
        arc.linewidth = 0.7;
        this.group.add(arc);
        const leftArc = Rows_1.Rows.makeArrow("up");
        leftArc.translation.set(radius / 2 + arc.vertices[0].x - 7, radius / 2 + arc.vertices[0].y - 2);
        leftArc.rotation = -Math.PI / 12;
        this.group.add(leftArc);
        const rightArc = Rows_1.Rows.makeArrow("down");
        rightArc.translation.set(radius + (or - (radius / 2)) - 7, radius / 2 - 10);
        this.group.add(rightArc);
        this.group.add(this.two.makeText((num === 8) ? "30°" : "22.5°", radius / 2 + arc.vertices[Math.round(arc.vertices.length / 4)].x + 10, radius / 2 + arc.vertices[Math.round(arc.vertices.length / 4)].y, QuatableElement_1.QuotableElement.STYLE_LEFT));
        let arc1 = null;
        if (num === 8) {
            arc1 = this.drawArc(two, radius / 2, radius / 2, or, -(3 / 4 * Math.PI), -(Math.PI - Math.PI / 12));
        }
        else {
            arc1 = this.drawArc(two, radius / 2, radius / 2, or, -(3 / 4 * Math.PI), -(Math.PI));
        }
        arc1.linewidth = 0.7;
        this.group.add(arc1);
        this.group.add(this.two.makeText((num === 8) ? "30°" : "45°", radius / 2 + arc1.vertices[Math.round(arc1.vertices.length / 4)].x - 25, radius / 2 + arc1.vertices[Math.round(arc1.vertices.length / 4)].y - 5, QuatableElement_1.QuotableElement.STYLE_LEFT));
        const rightArc1 = Rows_1.Rows.makeArrow("down");
        rightArc1.translation.set((radius / 2) - or - (num === 6 ? 7 : 0), (radius / 2) + (Math.max.apply(Math, arc1.vertices.map((o) => { return o.y; }))) - 12 /*radius / 2 - 10*/);
        rightArc1.rotation = (num === 6) ? 0 : Math.PI / 12;
        this.group.add(rightArc1);
        const leftArc1 = Rows_1.Rows.makeArrow("up");
        leftArc1.rotation = Math.PI / 5;
        leftArc1.translation.set((or - (radius / 2)) - 5, (or - (radius / 2)) - 9);
        this.group.add(leftArc1);
        let arc2 = null;
        if (num === 6) {
            arc2 = this.drawArc(two, radius / 2, radius / 2, or, -Math.PI, -(Math.PI + Math.PI / 4));
        }
        else {
            arc2 = this.drawArc(two, radius / 2, radius / 2, or, -Math.PI - Math.PI / 12, -(Math.PI + Math.PI / 4));
        }
        arc2.linewidth = 0.7;
        this.group.add(arc2);
        this.group.add(this.two.makeText((num === 8) ? "30°" : "45°", radius / 2 + arc2.vertices[Math.round(arc2.vertices.length / 4)].x - 22, radius / 2 + arc2.vertices[Math.round(arc2.vertices.length / 4)].y + 12, QuatableElement_1.QuotableElement.STYLE_LEFT));
        const rightArc2 = Rows_1.Rows.makeArrow("up");
        rightArc2.translation.set(-(or - (radius / 2)) - (num === 6 ? 7 : 4), radius / 2 + arc2.vertices[0].y - (num === 6 ? 0 : 2));
        rightArc2.rotation = (num === 6) ? 0 : -(Math.PI / 12);
        this.group.add(rightArc2);
        const leftArc2 = Rows_1.Rows.makeArrow("down");
        leftArc2.translation.set(radius / 2 - (Math.max.apply(Math, arc2.vertices.map((o) => { return o.y; }))) - 13, radius / 2 + (Math.max.apply(Math, arc2.vertices.map((o) => { return o.y; }))) - 3);
        leftArc2.rotation = -(Math.PI / 4);
        this.group.add(leftArc2);
        if (num === 8) {
            const arc3 = this.drawArc(two, radius / 2, radius / 2, or, -Math.PI + Math.PI / 12, -Math.PI - Math.PI / 12);
            arc3.linewidth = 0.7;
            this.group.add(arc3);
            this.group.add(this.two.makeText("30°", -(or - radius / 2) - 25, radius / 2, QuatableElement_1.QuotableElement.STYLE_LEFT));
            const rightArc3 = Rows_1.Rows.makeArrow("up");
            rightArc3.translation.set(-(or - (radius / 2)) - 2, radius / 2 + arc3.vertices[0].y - 5);
            rightArc3.rotation = Math.PI / 12;
            this.group.add(rightArc3);
            const leftArc3 = Rows_1.Rows.makeArrow("down");
            leftArc3.translation.set(-(or - (radius / 2)) - 6, radius / 2 - arc3.vertices[0].y - 9);
            leftArc3.rotation = -(Math.PI / 12);
            this.group.add(leftArc3);
            const arc4 = this.drawArc(two, radius / 2, radius / 2, or, Math.PI / 12, 0);
            arc4.linewidth = 0.7;
            this.group.add(arc4);
            this.group.add(this.two.makeText("15°", radius + (or - radius / 2) + 7, radius / 2 + (Math.max.apply(Math, arc4.vertices.map((o) => { return o.y; })) / 2), QuatableElement_1.QuotableElement.STYLE_LEFT));
            const rightArc4 = Rows_1.Rows.makeArrow("up");
            rightArc4.translation.set(radius + (or - (radius / 2)) - 7, radius / 2 - 3);
            this.group.add(rightArc4);
            const leftArc4 = Rows_1.Rows.makeArrow("down");
            leftArc4.translation.set(radius + (or - (radius / 2)) - 8, (radius / 2) + arc4.vertices[0].y - 11);
            leftArc4.rotation = Math.PI / 12;
            this.group.add(leftArc4);
        }
        return this.group;
    }
    /**
     * drawCustomerIdentifyQuote
     */
    drawCustomerIdentifyQuote() {
        let lineHead1 = Rows_1.Rows.draw(this.two, this.part4Obj.translation.x - 20, -(this.heightD1 / 4), this.part4Obj.translation.x - 20, -(this.heightD1 / 2 + 100), Rows_1.RowsStyle.Thread);
        this.group.add(lineHead1);
        let lineHeadHorizontal = Rows_1.Rows.draw(this.two, this.part4Obj.translation.x - 20, -(this.heightD1 / 2 + 100), this.part4Obj.translation.x, -(this.heightD1 / 2 + 100), Rows_1.RowsStyle.Thread);
        this.group.add(lineHeadHorizontal);
        const bottom = Rows_1.Rows.makeArrow("down");
        this.group.add(bottom);
        bottom.translation.set(this.part4Obj.translation.x - 27, -(this.heightD1 / 4) - 4);
        // Add svg
        this.two.load("/images/triangle.svg", (svg) => {
            this.group.add(svg);
            svg.translation.set(this.part4Obj.translation.x - 10, -(this.heightD1 / 2 + 115));
        });
        this.group.add(this.two.makeText("1", this.part4Obj.translation.x + 9, -(this.heightD1 / 2 + 95)));
    }
    /**
     * Draw angle radius quote
     * @param two
     * @param group
     * @param angle1
     * @param angle2
     * @param centerx
     * @param centery
     * @param radius
     * @param label
     * @param position
     */
    drawAngleRadius(two, group, angle1, angle2, centerx, centery, radius, label, position = "topright") {
        const arc = this.drawArc(two, centerx, centery, radius, angle1, angle2);
        arc.linewidth = 0.7;
        group.add(arc);
        let yCoord = null;
        let xCoord = null;
        if (position === "topright") {
            yCoord = centery + (Math.min.apply(Math, arc.vertices.map((o) => { return o.y; })) / 2);
            xCoord = radius + (Math.max.apply(Math, arc.vertices.map((o) => { return o.x; })));
        }
        else if (position === "bottomright") {
            yCoord = centery + (Math.max.apply(Math, arc.vertices.map((o) => { return o.y; })) / 2);
            xCoord = radius + (Math.max.apply(Math, arc.vertices.map((o) => { return o.x; })));
        }
        else if (position === "bottomleft") {
            yCoord = centery + (Math.max.apply(Math, arc.vertices.map((o) => { return o.y; })) / 2);
            xCoord = radius + (Math.min.apply(Math, arc.vertices.map((o) => { return o.x; }))) - 30;
        }
        this.group.add(this.two.makeText(label, xCoord, yCoord, QuatableElement_1.QuotableElement.STYLE_CENTER));
    }
    /**
     * Draw inner ball inside a snail
     * @param two
     * @param base
     * @param radius
     * @param radiusMini
     * @param num
     */
    drawInnerCircle(two, base, radius, radiusMini, num = 6, ballScrew) {
        const smallRadius = radius / 2.4;
        const ycomp = (smallRadius * Math.sqrt(2));
        const cx = radius;
        const cy = radius;
        // Common circle for all snail type
        const circ1 = two.makeCircle(cx - ycomp, cy - ycomp, radiusMini);
        circ1.noFill();
        base.add(circ1);
        const circ2 = two.makeCircle(cx - ycomp, cy + ycomp, radiusMini);
        circ2.noFill();
        base.add(circ2);
        const circ3 = two.makeCircle(cx + ycomp, cy + ycomp, radiusMini);
        circ3.noFill();
        base.add(circ3);
        const circ4 = two.makeCircle(cx + ycomp, cy - ycomp, radiusMini);
        circ4.noFill();
        base.add(circ4);
        this.registerForQuote([circ3], "right", Math.PI / 4, "Ø " + parseFloat(ballScrew.D5.toString()).toFixed(0).toString() + " H13");
        if (num === 6) {
            const circ5 = two.makeCircle(cx + smallRadius * 2, cy, radiusMini);
            circ5.noFill();
            base.add(circ5);
            const circ6 = two.makeCircle(cx - smallRadius * 2, cy, radiusMini);
            circ6.noFill();
            base.add(circ6);
        }
        else {
            // Calculate coordinates
            const delta = smallRadius * 2;
            const cospid = Math.cos(Math.PI / 12);
            const sinpid = Math.sin(Math.PI / 12);
            const xa = cx - (delta * cospid);
            const ya = cy - (delta * sinpid);
            const xb = cx - (delta * cospid);
            const yb = cy + (delta * sinpid);
            const xc = cx + (delta * cospid);
            const yc = cy - (delta * sinpid);
            const xd = cx + (delta * cospid);
            const yd = cy + (delta * sinpid);
            const circ7 = two.makeCircle(xa, ya, radiusMini);
            circ7.noFill();
            base.add(circ7);
            const circ8 = two.makeCircle(xb, yb, radiusMini);
            circ8.noFill();
            base.add(circ8);
            const circ9 = two.makeCircle(xc, yc, radiusMini);
            circ9.noFill();
            base.add(circ9);
            const circ10 = two.makeCircle(xd, yd, radiusMini);
            circ10.noFill();
            base.add(circ10);
        }
    }
    /**
     * Create circle base for snail with no flatted sides
     * @param two
     * @param radius
     */
    drawCircleBase(two, ballScrew, scale) {
        const radius = (ballScrew.D6 * scale) / 2;
        const screw = two.makeGroup();
        const base = two.makeCircle(radius, radius, radius);
        this.registerForQuote([base], "right", Math.PI / 2.5, "Ø " + parseFloat(ballScrew.D6.toString()).toFixed(0).toString() + " h13");
        const d1Circle = two.makeCircle(radius, radius, (ballScrew.D1 * scale) / 2);
        d1Circle.linewidth = 2;
        const d0Circle = two.makeCircle(radius, radius, (ballScrew.nominal_diameter * scale) / 2);
        const innerBase = two.makeCircle(radius, radius, radius / 1.2);
        innerBase.dashes = Rows_1.Rows.getDashesForStyle(Rows_1.RowsStyle.Axis);
        this.registerForQuote([innerBase], "right", -Math.PI / 3, "Ø " + parseFloat(ballScrew.D4.toString()).toFixed(0).toString() + " -0.2 / +0.2");
        screw.add(base);
        screw.add(innerBase);
        screw.add(d1Circle);
        screw.add(d0Circle);
        return screw;
    }
    /**
     * Draw arc for a snail with bottom flat side
     * @param two
     * @param radius
     */
    drawCircleBottomFlat(two, ballScrew, scale) {
        // Groups can take an array of shapes and/or groups.
        const radius = (ballScrew.D6 * scale);
        const screw = two.makeGroup();
        const or = radius / 2;
        const sa = (Math.PI / 4) * 3;
        const ea = (Math.PI / 4) * 9;
        this.addAdditionalQuotes(two, radius, screw, ballScrew);
        screw.add(this.drawArc(two, or, or, or, sa, ea));
        const innerArc = this.drawArc(two, or, or, or / 1.18, sa, ea);
        innerArc.dashes = Rows_1.Rows.getDashesForStyle(Rows_1.RowsStyle.Axis);
        screw.add(innerArc);
        const mod1 = sa - (Math.PI / 2);
        const x1 = (or - (or * (Math.sin(mod1))));
        const y1 = (or + (or * (Math.cos(mod1))));
        const mod = (Math.PI / 2) - ea % (2 * Math.PI);
        const x2 = (or + (or * (Math.sin(mod))));
        const y2 = (or + (or * (Math.cos(mod))));
        const line = two.makeLine(x1, y1, x2, y2);
        screw.add(line);
        const d1Circle = two.makeCircle(radius / 2, radius / 2, (ballScrew.D1 * scale) / 2);
        d1Circle.linewidth = 2;
        const d0Circle = two.makeCircle(radius / 2, radius / 2, (ballScrew.nominal_diameter * scale) / 2);
        screw.add(d1Circle);
        screw.add(d0Circle);
        return screw;
    }
    /**
     * Draw arc
     * @param two
     * @param ox
     * @param oy
     * @param or
     * @param sa
     * @param ea
     */
    drawArc(two, ox, oy, or, sa, ea) {
        return two.makeArcSegment(ox, oy, or, or, sa, ea);
    }
    /**
     * Draw arc for a snail with top flat side
     * @param two
     * @param radius
     */
    drawCircleTopFlat(two, ballScrew, scale) {
        const radius = (ballScrew.D6 * scale);
        const top = this.drawCircleBottomFlat(two, ballScrew, scale);
        top.translation.set(radius, radius);
        top.rotation = Math.PI;
        return top;
    }
    /**
     * Draw arcs for a snail with both flat sides
     * @param two
     * @param radius
     */
    drawCircleBothFlat(two, ballScrew, scale) {
        // Calculate coordinates
        const radius = (ballScrew.D6 * scale);
        const or = radius / 2;
        const sa = (Math.PI / 4) * 3;
        const ea = (Math.PI / 4) * 5;
        const sa1 = -(Math.PI / 4);
        const ea1 = Math.PI / 4;
        const mod1 = -(-(Math.PI / 2) - sa1);
        const x2 = (or + (or * (Math.sin(mod1))));
        const y2 = (or - (or * (Math.cos(mod1))));
        const mod = (Math.PI / 2) - ea % (2 * Math.PI);
        const x1 = (or + (or * (Math.sin(mod))));
        const y1 = (or + (or * (Math.cos(mod))));
        const mod2 = Math.PI / 2 - ea1;
        const mod4 = (Math.PI * 1.5) - ea;
        const y3 = (or + (or * (Math.cos(mod4))));
        const y4 = (or + (or * (Math.cos(mod2))));
        const screw = two.makeGroup();
        this.addAdditionalQuotes(two, radius, screw, ballScrew);
        screw.add(this.drawLeftRightArc(two, radius, or, or, ea, sa, ea1, sa1));
        screw.add(this.drawLeftRightArc(two, radius / 1.18, or, or, ea, sa, ea1, sa1, Rows_1.RowsStyle.Axis));
        const line2 = two.makeLine(x1, y1, x2, y2);
        screw.add(line2);
        const line = two.makeLine(x1, y3, x2, y4);
        screw.add(line);
        const d1Circle = two.makeCircle(radius / 2, radius / 2, (ballScrew.D1 * scale) / 2);
        d1Circle.linewidth = 2;
        const d0Circle = two.makeCircle(radius / 2, radius / 2, (ballScrew.nominal_diameter * scale) / 2);
        screw.add(d1Circle);
        screw.add(d0Circle);
        return screw;
    }
    addAdditionalQuotes(two, radius, screw, ballScrew) {
        const base = two.makeCircle(radius / 2, radius / 2, radius / 2);
        base.noStroke();
        screw.add(base);
        this.registerForQuote([base], "right", Math.PI / 7, "Ø " + parseFloat(ballScrew.D6.toString()).toFixed(0).toString() + " h13");
        const innerBase = two.makeCircle(radius / 2, radius / 2, (radius / 2.38));
        innerBase.noStroke();
        screw.add(innerBase);
        this.registerForQuote([innerBase], "right", -Math.PI / 4, "Ø " + parseFloat(ballScrew.D4.toString()).toFixed(0).toString() + " -0.2 / +0.2");
    }
    /**
     * Draw left and right arc for a snail with bottom flat side
     * @param two
     * @param diameter
     * @param ox
     * @param oy
     * @param ea
     * @param sa
     * @param ea1
     * @param sa1
     * @param style
     */
    drawLeftRightArc(two, diameter, ox, oy, ea, sa, ea1, sa1, style = Rows_1.RowsStyle.Normal) {
        const screw = two.makeGroup();
        const or = diameter / 2;
        const arc = two.makeArcSegment(ox, oy, or, or, sa, ea);
        arc.dashes = Rows_1.Rows.getDashesForStyle(style);
        screw.add(arc);
        const arc1 = two.makeArcSegment(ox, oy, or, or, sa1, ea1);
        arc1.dashes = Rows_1.Rows.getDashesForStyle(style);
        screw.add(arc1);
        return screw;
    }
    /**
     * Draw all innercircle axis
     * @param two
     * @param base
     * @param diameter
     * @param num
     */
    drawAxis(two, base, diameter, num = 6) {
        // Calculate coordinates
        const cx = diameter / 2;
        const cy = diameter / 2;
        const newRadius = (diameter / 2) * 1.25;
        const teta = Math.sin(Math.PI / 4);
        const x1 = cx - newRadius * teta;
        const y1 = cy - newRadius * teta;
        const x2 = cx + newRadius * teta;
        const y2 = cy + newRadius * teta;
        const delta = (diameter / 2) * 1.25;
        // Hole indicator
        let coseholep = 0;
        let sinholep = 0;
        let xh = 0;
        let yh = 0;
        let xh1 = 0;
        let yh1 = 0;
        const left = Rows_1.Rows.makeArrow("left");
        const line = two.makeLine(x1, y1, x2, y2);
        line.dashes = Rows_1.Rows.getDashesForStyle(Rows_1.RowsStyle.Axis);
        line.linewidth = 1;
        base.add(line);
        const line1 = two.makeLine(x2, y1, x1, y2);
        line1.dashes = Rows_1.Rows.getDashesForStyle(Rows_1.RowsStyle.Axis);
        line1.linewidth = 1;
        base.add(line1);
        const line2 = two.makeLine(-(diameter / 8), diameter / 2, diameter + (diameter / 8), diameter / 2);
        line2.dashes = Rows_1.Rows.getDashesForStyle(Rows_1.RowsStyle.Axis);
        line2.linewidth = 1;
        base.add(line2);
        if (num === 6) {
            coseholep = Math.cos(Math.PI / 8); // 30° hole indicator
            sinholep = Math.sin(Math.PI / 8); // 30° hole indicator
            left.rotation = -Math.PI / 8;
            xh1 = cx + ((delta + 20) * coseholep);
            yh1 = cy - ((delta + 20) * sinholep);
            const line3 = two.makeLine(diameter / 2, -(diameter / 8), diameter / 2, diameter + diameter / 8);
            line3.dashes = Rows_1.Rows.getDashesForStyle(Rows_1.RowsStyle.Axis);
            line3.linewidth = 1;
            base.add(line3);
        }
        else {
            const cospid = Math.cos(Math.PI / 12); // 15°
            const sinpid = Math.sin(Math.PI / 12); // 15°
            const xa = cx - (delta * cospid);
            const ya = cy - (delta * sinpid);
            const xb = cx - (delta * cospid);
            const yb = cy + (delta * sinpid);
            const xc = cx + (delta * cospid);
            const yc = cy - (delta * sinpid);
            const xd = cx + (delta * cospid);
            const yd = cy + (delta * sinpid);
            coseholep = Math.cos(Math.PI / 6); // 30° hole indicator
            sinholep = Math.sin(Math.PI / 6); // 30° hole indicator
            left.rotation = -Math.PI / 6;
            xh1 = cx + ((delta + 20) * coseholep);
            yh1 = cy - ((delta + 20) * sinholep);
            const linevert = two.makeLine(xa, ya, xd, yd);
            const line3 = two.makeLine(diameter / 2, -(diameter / 8), diameter / 2, diameter + diameter / 8);
            line3.dashes = Rows_1.Rows.getDashesForStyle(Rows_1.RowsStyle.Axis);
            line3.linewidth = 1;
            base.add(line3);
            linevert.dashes = Rows_1.Rows.getDashesForStyle(Rows_1.RowsStyle.Axis);
            linevert.linewidth = 1;
            base.add(linevert);
            const linevert1 = two.makeLine(xb, yb, xc, yc);
            linevert1.dashes = Rows_1.Rows.getDashesForStyle(Rows_1.RowsStyle.Axis);
            linevert1.linewidth = 1;
            base.add(linevert1);
        }
        xh = cx + ((diameter / 2) * coseholep);
        yh = cy - ((diameter / 2) * sinholep);
        const holeAxisLine = two.makeLine(cx, cy, xh, yh);
        holeAxisLine.dashes = Rows_1.Rows.getDashesForStyle(Rows_1.RowsStyle.Axis);
        holeAxisLine.linewidth = 1;
        base.add(holeAxisLine);
        const holeline = two.makeLine(xh, yh, xh1, yh1);
        holeline.dashes = Rows_1.Rows.getDashesForStyle(Rows_1.RowsStyle.Normal);
        holeline.linewidth = 1;
        base.add(holeline);
        const holeline1 = two.makeLine(xh1, yh1, xh1 + 60, yh1);
        holeline1.dashes = Rows_1.Rows.getDashesForStyle(Rows_1.RowsStyle.Normal);
        holeline1.linewidth = 1;
        base.add(holeline1);
        // Add svg
        two.load("/images/oil.svg", (svg) => {
            base.add(svg);
            svg.translation.set(xh1 + 10, yh1 - 40);
        });
        base.add(two.makeText("LUB. M8X1", xh1 + 4, yh1 - 10, QuatableElement_1.QuotableElement.STYLE_LEFT));
        left.translation.set(xh - 5, yh - 5);
        base.add(left);
    }
}
exports.Snail = Snail;
